import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-26" data-mp="br2fl907l19x">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:p-0" initial={{
      y: 120,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 120,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-27" data-mp="bpzqn6mg58wn">
          <motion.a href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-2.5 rounded-2xl bg-cta px-6 py-4 font-display text-lg font-bold uppercase tracking-wide text-white shadow-[0_6px_0_0_#9f1239,0_12px_30px_rgba(11,37,89,0.3)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-sun sm:w-auto" animate={reduce ? undefined : {
        x: [0, -7, 7, -6, 6, -3, 3, 0],
        rotate: [0, -1.5, 1.5, -1.5, 1.5, 0, 0, 0]
      }} transition={{
        duration: 0.45,
        repeat: Infinity,
        repeatDelay: 1.4,
        ease: "easeInOut"
      }} data-id="element-28" data-mp="2b4tasdxyutdi">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-29" data-mp="1ifut1hxr9t8q" />
            <span className="whitespace-nowrap" data-id="element-30" data-mp="1ndedizl1r294">Get it now · $27</span>
          </motion.a>
        </motion.div>}
    </AnimatePresence>;
}